import { isObject } from 'lodash';

export default function setupComplete(user) {
  if (user.type === 'admin') {
    return true;
  }

  if (user.nonprofit && isObject(user.nonprofit)) {
    return user.nonprofit.setup_complete;
  }

  if (user.corporation && isObject(user.corporation)) {
    return user.corporation.setup_complete;
  }

  return false;
}



// WEBPACK FOOTER //
// ./src/lib/setupComplete.js